// import { Box, Card, CardActionArea, CardContent, Grid, styled } from '@mui/material';
// import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
// import HowToRegIcon from '@mui/icons-material/HowToReg';
// import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
// import MoreTimeIcon from '@mui/icons-material/MoreTime';
// import EventRepeatIcon from '@mui/icons-material/EventRepeat';
// import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
// import CreditScoreIcon from '@mui/icons-material/CreditScore';
// import Typography from "@mui/material/Typography";
// import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
// import ConstructionIcon from '@mui/icons-material/Construction';
// import EditCalendarIcon from '@mui/icons-material/EditCalendar';
// import PsychologyIcon from '@mui/icons-material/Psychology';
// import VolumeUpIcon from '@mui/icons-material/VolumeUp';
// import ReceiptIcon from '@mui/icons-material/Receipt';
// import NotificationAddIcon from '@mui/icons-material/NotificationAdd';
// import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
// import QuizIcon from '@mui/icons-material/Quiz';
// import MarkUnreadChatAltIcon from '@mui/icons-material/MarkUnreadChatAlt';
// import { useTranslation } from "react-i18next";
// import { useTheme } from '@mui/system';
// import i18n from '../../../i18n';
// import { motion } from "framer-motion"


// export const WhyWe = () => {
//     const { t } = useTranslation();
//     const theme = useTheme();

//     const hire = [
//         {
//             id: Math.random(),
//             title: (i18n.language === "en" ? "Smart Contract" : "Contrat intelligent"),
//             icon: VolumeUpIcon
//         },
//         {
//             id: Math.random(),
//             title: (i18n.language === "en" ? "Appointment Scheduler" : "Planificateur de rendez-vous"),
//             icon: EditCalendarIcon
//         },
//         {
//             id: Math.random(),
//             title: (i18n.language === "en" ? "Job Scheduler" : "Planificateur des demandes"),
//             icon: AppRegistrationIcon
//         },
//         {
//             id: Math.random(),
//             title: (i18n.language === "en" ? "Job tracker" : "Suiveur de mission"),
//             icon: HowToRegIcon
//         },
//         {
//             id: Math.random(),
//             title: (i18n.language === "en" ? "Invoicing" : "Facturation"),
//             icon: ReceiptIcon
//         },
//         {
//             id: Math.random(),
//             title: (i18n.language === "en" ? "Payment System" : "Système de paiement"),
//             icon: AssuredWorkloadIcon
//         },
//         {
//             id: Math.random(),
//             title: (i18n.language === "en" ? "Notifications" : "Notifications"),
//             icon: NotificationAddIcon
//         },
//         {
//             id: Math.random(),
//             title: (i18n.language === "en" ? "Integrated Chat" : "Chat intégré"),
//             icon: MarkUnreadChatAltIcon
//         },
//         {
//             id: Math.random(),
//             title: (i18n.language === "en" ? "Generative Ai" : "Ai générative"),
//             icon: PsychologyIcon
//         }
//     ]

//     const become = [
//         {
//             id: Math.random(),
//             title: "Register",
//             // description: "Create profile",
//             icon: AppRegistrationIcon
//         },
//         {
//             id: Math.random(),
//             title: "Setup payment method",
//             // description: "you can receive pay for your services with both fiat and crypto",
//             icon: MonetizationOnIcon
//         },
//         {
//             id: Math.random(),
//             title: "Set your hourly rates",
//             // description: "",
//             icon: MoreTimeIcon
//         },
//         {
//             id: Math.random(),
//             title: "Set your calendar availability ",
//             // description: "",
//             icon: EventRepeatIcon
//         },
//         {
//             id: Math.random(),
//             title: "Provide best service possible to the client ",
//             // description: "then approve your profile",
//             icon: MilitaryTechIcon
//         },
//         {
//             id: Math.random(),
//             title: "Get paid",
//             // description: "For Pro",
//             icon: CreditScoreIcon
//         }
//     ]

//     // Styled component for creating a pentagon shape
//     const PentagonCardActionArea = styled(CardActionArea)({
//         clipPath: 'polygon(40% 0%, 60% 0%, 100% 50%, 60% 100%, 40% 100%, 0% 50%)',
//         backgroundColor: "#F9FAFB",
//         borderRadius: "10px",
//     });

//     return (
//         <Box
//             sx={{
//                 backgroundColor: "#f2f5f7",
//                 paddingBottom: '20px',
//                 backgroundSize: 'cover',
//                 marginTop: '0px'
//             }}
//         >
//             <Typography fontSize={28} fontWeight="600" align="center" variant="h3" sx={{ margin: "0px 0px", padding: '10px', color: '#16A34A' }}>

//                 <Typography fontSize={24} fontWeight="600" align="center" variant="h3"
//                     sx={{
//                         marginTop: "50px",
//                         borderRadius: '30px',
//                         padding: '20px',
//                         color: '#32325d',
//                         backgroundColor: "#F9FAFB",
//                         display: 'inline-block', // Set display to inline-block
//                         width: 'auto', // Set width to auto
//                     }}
//                 >
//                     <ConstructionIcon sx={{ color: '#FF7600' }} /> {t('WhyWe.seemlessTolls')}
//                 </Typography>
//             </Typography>
//             <Grid
//                 container
//                 direction="row"
//                 justifyContent="center"
//                 alignItems="center"
//                 spacing={2}
//                 wrap="wrap"
//                 sx={{
//                     padding: "0 5vw"
//                 }}
//             >
//                 {hire.map((step, index) => (
//                     <Grid item xs={4} sm={6} md={1} key={step.id}>
//                         <motion.div
//                             initial={{
//                                 scale: 0
//                             }}
//                             whileInView={{
//                                 scale: 1
//                             }}
//                             transition={{
//                                 duration: 1
//                             }}
//                             viewport={{ once: true }}
//                         >
//                             <Card sx={{ borderRadius: "50%", width: 100, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0px 0px 20px 8px rgba(22, 163, 74, 0.2)' }}>
//                                 <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
//                                     <step.icon sx={{ color: '#FF7600', fontSize: 25 }} />
//                                     <Box sx={{ mt: 2 }}>
//                                         <Typography sx={{ fontSize: 12 }} align="center">{step.title}</Typography>
//                                     </Box>
//                                 </CardContent>
//                             </Card>
//                         </motion.div>
//                     </Grid>
//                 ))}
//             </Grid>

//             <Grid item xs={12} sm={12} md={4} m={2}>
//                 <Typography fontSize={28} fontWeight="600" align="center" variant="h3"
//                     sx={{
//                         color: '#32325d',
//                         margin: '0',
//                         background: 'linear-gradient(to right, rgba(224, 224, 224, 1), rgba(224, 224, 224, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))',
//                         borderRadius: "10px 10px 0 0",
//                         padding: '20px',
//                         transition: 'box-shadow 0.3s ease-in-out', // Note the quotes around the property value
//                         boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)', // Add the desired shadow on hover
//                     }}
//                 >
//                     <EmojiEventsIcon sx={{ color: '#FF7600' }} /> {t('WhyWe.cuttingEdgeTitle')}
//                     <Typography fontSize={18} fontWeight="600" align="center" variant="h3" sx={{ paddingTop: '10px', color: '#32325d' }}>
//                         <QuizIcon sx={{ color: '#FF7600' }} /> {t('WhyWe.noMore')}
//                     </Typography>
//                 </Typography>
//                 <Typography
//                     align="center"
//                     sx={{
//                         backgroundColor: "#F9FAFB",
//                         borderRadius: "0 0 10px 10px",
//                         padding: '20px',
//                         transition: 'box-shadow 0.3s ease-in-out', // Note the quotes around the property value
//                         boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)', // Add the desired shadow on hover
//                     }}
//                 >
//                     {t('WhyWe.cuttingEdgeBody')}
//                 </Typography>
//             </Grid>
//         </Box>
//     );
// };





import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ConstructionIcon from '@mui/icons-material/Construction';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import PsychologyIcon from '@mui/icons-material/Psychology';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import ReceiptIcon from '@mui/icons-material/Receipt';
import NotificationAddIcon from '@mui/icons-material/NotificationAdd';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import QuizIcon from '@mui/icons-material/Quiz';
import MarkUnreadChatAltIcon from '@mui/icons-material/MarkUnreadChatAlt';
import { useTranslation } from "react-i18next";
import i18n from '../../../i18n';
import { motion } from "framer-motion";

export const WhyWe = () => {
    const { t } = useTranslation();

    const hire = [
        { id: 1, title: i18n.language === "en" ? "Smart Contract" : "Contrat intelligent", icon: VolumeUpIcon },
        { id: 2, title: i18n.language === "en" ? "Appointment Scheduler" : "Planificateur de rendez-vous", icon: EditCalendarIcon },
        { id: 3, title: i18n.language === "en" ? "Job Scheduler" : "Planificateur des demandes", icon: AppRegistrationIcon },
        { id: 4, title: i18n.language === "en" ? "Job tracker" : "Suiveur de mission", icon: HowToRegIcon },
        { id: 5, title: i18n.language === "en" ? "Invoicing" : "Facturation", icon: ReceiptIcon },
        { id: 6, title: i18n.language === "en" ? "Payment System" : "Système de paiement", icon: AssuredWorkloadIcon },
        { id: 7, title: i18n.language === "en" ? "Notifications" : "Notifications", icon: NotificationAddIcon },
        { id: 8, title: i18n.language === "en" ? "Integrated Chat" : "Chat intégré", icon: MarkUnreadChatAltIcon },
        { id: 9, title: i18n.language === "en" ? "Generative Ai" : "Ai générative", icon: PsychologyIcon }
    ];

    const become = [
        { id: 1, title: "Register", icon: AppRegistrationIcon },
        { id: 2, title: "Setup payment method", icon: MonetizationOnIcon },
        { id: 3, title: "Set your hourly rates", icon: MoreTimeIcon },
        { id: 4, title: "Set your calendar availability", icon: EventRepeatIcon },
        { id: 5, title: "Provide best service possible to the client", icon: MilitaryTechIcon },
        { id: 6, title: "Get paid", icon: CreditScoreIcon }
    ];

    return (
        <Box
            sx={{
                backgroundColor: "#112240",
                paddingBottom: "40px",
                marginTop: 0,
                paddingX: { xs: 2, md: 6 },
                paddingY: 6,
            }}
        >
            {/* Title */}
            <Typography
                fontSize={28}
                fontWeight="600"
                align="center"
                variant="h3"
                sx={{
                    mb: 4,
                    color: "#fff", // ✅ will now apply
                }}
            >
                <ConstructionIcon sx={{ color: "#fff", mr: 1 }} />
                {t('WhyWe.seemlessTolls')}
            </Typography>


            {/* Hire section */}
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                wrap="wrap"
            >
                {hire.map((step, index) => (
                    <Grid item xs={4} sm={6} md={1} key={step.id}>
                        <motion.div
                            initial={{ scale: 0 }}
                            whileInView={{ scale: 1 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: true }}
                        >
                            <Card
                                sx={{
                                    borderRadius: "50%",
                                    width: 100,
                                    height: 100,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: "rgba(255,255,255,0.05)",
                                    backdropFilter: "blur(6px)",
                                    border: "1px solid rgba(255,255,255,0.1)",
                                    boxShadow: "0 0 15px rgba(147, 51, 234, 0.3)",
                                    transition: "all 0.3s ease",
                                    "&:hover": {
                                        transform: "translateY(-6px)",
                                        boxShadow: "0 0 22px rgba(100, 255, 218, 0.6)",
                                    },
                                }}
                            >
                                <CardContent
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <step.icon sx={{ color: "#64FFDA", fontSize: 25 }} />
                                    <Box sx={{ mt: 2 }}>
                                        <Typography sx={{ fontSize: 12, color: "#fff" }} align="center">
                                            {step.title}
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        </motion.div>
                    </Grid>
                ))}
            </Grid>

            {/* Become section */}
            <Grid item xs={12} sm={12} md={4} m={2}>
                <Typography
                    fontSize={28}
                    fontWeight="600"
                    align="center"
                    variant="h3"
                    sx={{
                        color: "#64FFDA",
                        margin: "0",
                        background: 'linear-gradient(135deg, #3b0764, #9333ea)',
                        borderRadius: "10px 10px 0 0",
                        padding: "20px",
                        boxShadow: "0px 4px 12px rgba(0,0,0,0.4)",
                    }}
                >
                    <EmojiEventsIcon sx={{ color: "#9333ea", mr: 1 }} />
                    {t('WhyWe.cuttingEdgeTitle')}
                    <Typography
                        fontSize={18}
                        fontWeight="600"
                        align="center"
                        sx={{ paddingTop: "10px", color: "#fff" }}
                    >
                        <QuizIcon sx={{ color: "#9333ea", mr: 1 }} />
                        {t('WhyWe.noMore')}
                    </Typography>
                </Typography>
                <Typography
                    align="center"
                    sx={{
                        backgroundColor: "rgba(255,255,255,0.05)",
                        borderRadius: "0 0 10px 10px",
                        padding: "20px",
                        color: "#fff",
                        backdropFilter: "blur(6px)",
                    }}
                >
                    {t('WhyWe.cuttingEdgeBody')}
                </Typography>
            </Grid>
        </Box>
    );
};
